import React from 'react';

export default function PrivacyPolicy(): React.JSX.Element {
    return (
        <div className="prose prose-sm max-w-none">
            <h1 className="text-2xl font-bold mb-6 bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
                Политика конфиденциальности
            </h1>

            <p className="text-gray-600 mb-4">
                Дата последнего обновления: 21 апреля 2026 года
            </p>

            <section className="mb-6">
                <h2 className="text-xl font-semibold text-gray-900 mb-3">
                    1. Общие положения
                </h2>
                <p className="text-gray-700 mb-2">
                    Настоящая Политика конфиденциальности определяет порядок обработки и
                    защиты персональных данных пользователей сервиса генерации песен
                    (далее — «Сервис»).
                </p>
                <p className="text-gray-700">
                    Используя Сервис, вы соглашаетесь с условиями настоящей Политики
                    конфиденциальности.
                </p>
            </section>

            <section className="mb-6">
                <h2 className="text-xl font-semibold text-gray-900 mb-3">
                    2. Собираемые данные
                </h2>
                <p className="text-gray-700 mb-2">
                    Мы можем собирать следующие типы данных:
                </p>
                <ul className="list-disc pl-6 text-gray-700 space-y-1">
                    <li>
                        Информация, предоставленная при использовании Сервиса (название
                        песен, тексты, выбранные стили)
                    </li>
                    <li>
                        Технические данные (IP-адрес, тип браузера, операционная система)
                    </li>
                    <li>
                        Данные о взаимодействии с Сервисом (время использования, клики,
                        действия)
                    </li>
                    <li>Платежная информация (при совершении покупок)</li>
                </ul>
            </section>

            <section className="mb-6">
                <h2 className="text-xl font-semibold text-gray-900 mb-3">
                    3. Цели обработки данных
                </h2>
                <p className="text-gray-700 mb-2">
                    Мы используем собранные данные для:
                </p>
                <ul className="list-disc pl-6 text-gray-700 space-y-1">
                    <li>Предоставления и улучшения Сервиса</li>
                    <li>Генерации музыкального контента на основе ваших запросов</li>
                    <li>
                        Обработки платежей и предоставления доступа к приобретенным
                        материалам
                    </li>
                    <li>Технической поддержки пользователей</li>
                    <li>Анализа использования Сервиса и улучшения функциональности</li>
                    <li>Соблюдения законодательных требований</li>
                </ul>
            </section>

            <section className="mb-6">
                <h2 className="text-xl font-semibold text-gray-900 mb-3">
                    4. Защита данных
                </h2>
                <p className="text-gray-700">
                    Мы применяем современные технические и организационные меры для защиты
                    ваших персональных данных от несанкционированного доступа, изменения,
                    раскрытия или уничтожения. Все данные передаются по защищенным каналам
                    связи.
                </p>
            </section>

            <section className="mb-6">
                <h2 className="text-xl font-semibold text-gray-900 mb-3">
                    5. Передача данных третьим лицам
                </h2>
                <p className="text-gray-700 mb-2">
                    Мы не передаем ваши персональные данные третьим лицам, за исключением
                    следующих случаев:
                </p>
                <ul className="list-disc pl-6 text-gray-700 space-y-1">
                    <li>С вашего явного согласия</li>
                    <li>Для обработки платежей (платежные системы)</li>
                    <li>При требовании законодательства или по решению суда</li>
                    <li>
                        Для предоставления технической поддержки (партнеры-подрядчики)
                    </li>
                </ul>
            </section>

            <section className="mb-6">
                <h2 className="text-xl font-semibold text-gray-900 mb-3">
                    6. Cookies и аналогичные технологии
                </h2>
                <p className="text-gray-700">
                    Мы используем файлы cookies для улучшения работы Сервиса, анализа
                    посещаемости и персонализации пользовательского опыта. Вы можете
                    отключить cookies в настройках браузера, однако это может повлиять на
                    функциональность Сервиса.
                </p>
            </section>

            <section className="mb-6">
                <h2 className="text-xl font-semibold text-gray-900 mb-3">
                    7. Ваши права
                </h2>
                <p className="text-gray-700 mb-2">Вы имеете право:</p>
                <ul className="list-disc pl-6 text-gray-700 space-y-1">
                    <li>Получить информацию о собранных данных</li>
                    <li>Запросить исправление неточных данных</li>
                    <li>Запросить удаление ваших персональных данных</li>
                    <li>Отозвать согласие на обработку данных</li>
                    <li>Ограничить обработку ваших данных</li>
                </ul>
            </section>

            <section className="mb-6">
                <h2 className="text-xl font-semibold text-gray-900 mb-3">
                    8. Хранение данных
                </h2>
                <p className="text-gray-700">
                    Мы храним ваши персональные данные в течение срока, необходимого для
                    достижения целей обработки, либо в течение срока, установленного
                    законодательством.
                </p>
            </section>

            <section className="mb-6">
                <h2 className="text-xl font-semibold text-gray-900 mb-3">
                    9. Изменения в Политике
                </h2>
                <p className="text-gray-700">
                    Мы оставляем за собой право вносить изменения в настоящую Политику
                    конфиденциальности. Актуальная версия всегда доступна на нашем сайте.
                    Продолжая использовать Сервис после внесения изменений, вы
                    соглашаетесь с обновленной Политикой.
                </p>
            </section>

            <section className="mb-6">
                <h2 className="text-xl font-semibold text-gray-900 mb-3">
                    10. Контактная информация
                </h2>
                <p className="text-gray-700">
                    По вопросам, связанным с обработкой персональных данных, вы можете
                    связаться с нами по электронной почте: privacy@music-generator.ru
                </p>
            </section>
        </div>
    );
}
